import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import { ScrollReveal } from "@/hooks/useScrollReveal";
import { Link } from "react-router-dom";
import Watermark from "@/components/base/Watermark";
import { SALES_CHANNELS } from "@/mocks/channels";
import { CATALOG_URL } from "@/mocks/site-config";

export default function StoresPage() {
  return (
    <>
      <Navbar />
      <main className="relative">
        <Watermark />
        {/* Hero */}
        <section className="min-h-[100svh] flex items-center bg-background-50 pt-16 md:pt-[68px]">
          <div className="mx-auto px-6 md:px-10 py-16 md:py-24 max-w-[1120px] w-full">
            <ScrollReveal>
              <div className="flex flex-col lg:flex-row lg:gap-16">
                <div className="lg:w-[30%] flex-shrink-0 mb-6 lg:mb-0">
                  <p className="text-xs tracking-[0.2em] uppercase text-foreground-400 font-medium">
                    Stores
                  </p>
                </div>
                <div className="lg:w-[70%] max-w-[620px]">
                  <h1 className="font-heading text-2xl md:text-3xl lg:text-4xl font-bold text-foreground-900 leading-tight mb-5">
                    合作購書通路
                  </h1>
                  <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-4">
                    崧燁文化事業有限公司的出版品可透過以下各大通路購買。各通路庫存、價格與配送方式以各平台實際顯示為準。
                  </p>
                  <p className="text-xs text-foreground-400 leading-relaxed">
                    完整 ISBN、定價與正式書目資訊，請前往崧博出版書籍資料庫查詢。
                  </p>
                </div>
              </div>
            </ScrollReveal>
          </div>
        </section>

        {/* Channels Grid */}
        <section className="min-h-[100svh] flex items-center bg-background-100 relative z-[2]">
          <div className="mx-auto px-6 md:px-10 py-16 md:py-24 max-w-[1120px] w-full">
            <ScrollReveal>
              <div className="lg:ml-[30%] lg:pl-16">
                <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-900 mb-2">
                  線上購書通路
                </h2>
                <p className="text-sm text-foreground-500 mb-10 leading-relaxed max-w-lg">
                  點擊下列通路名稱，前往各平台搜尋崧燁文化事業有限公司出版品
                </p>

                <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
                  {SALES_CHANNELS.map((ch) => (
                    <a
                      key={ch.name}
                      href={ch.url}
                      target="_blank"
                      rel="nofollow noopener noreferrer"
                      className="group flex items-center justify-between px-5 py-4 bg-white border border-background-200 hover:border-accent-300 transition-colors duration-200 cursor-pointer"
                    >
                      <span className="text-sm font-medium text-foreground-800 group-hover:text-accent-600 transition-colors">
                        {ch.name}
                      </span>
                      <i className="ri-external-link-line text-sm text-foreground-400 group-hover:text-accent-500 transition-colors"></i>
                    </a>
                  ))}
                </div>
              </div>
            </ScrollReveal>
          </div>
        </section>

        {/* Catalog CTA */}
        <section className="min-h-[50svh] flex items-center bg-background-50">
          <div className="mx-auto px-6 md:px-10 py-16 md:py-24 max-w-[1120px] w-full">
            <ScrollReveal>
              <div className="lg:ml-[30%] lg:pl-16 max-w-[620px]">
                <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-900 mb-4">
                  購書提醒
                </h2>
                <p className="text-sm text-foreground-600 leading-relaxed mb-6">
                  各通路書籍庫存狀態與上架時間不同，若在特定平台未找到您想購買的書籍，建議嘗試其他通路，或查詢崧博出版書籍資料庫以取得最完整的書目資訊。
                </p>
                <div className="flex flex-col sm:flex-row gap-3">
                  <a
                    href={CATALOG_URL}
                    target="_blank"
                    rel="nofollow noopener noreferrer"
                    className="bg-foreground-900 hover:bg-foreground-800 text-white px-6 py-3 text-sm font-medium whitespace-nowrap cursor-pointer transition-colors inline-flex items-center gap-2 justify-center rounded-md focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-foreground-400 focus-visible:ring-offset-2"
                  >
                    前往書籍資料庫 <i className="ri-external-link-line text-sm"></i>
                  </a>
                  <Link
                    to="/faq"
                    className="bg-secondary-500 hover:bg-secondary-600 text-white px-6 py-3 text-sm font-medium whitespace-nowrap cursor-pointer transition-colors inline-flex items-center gap-2 justify-center rounded-md focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-secondary-400 focus-visible:ring-offset-2"
                  >
                    常見問題 <i className="ri-question-line text-sm"></i>
                  </Link>
                </div>
              </div>
            </ScrollReveal>
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
}